module.exports = __webpack_public_path__ + "img/auto-5.4950a9f5.png";